import {Typography, Box, ListItemText} from "@material-ui/core";
import { AutoSizer, MultiGrid, CellMeasurer, CellMeasurerCache} from "react-virtualized";
import i18next from "../../i18n/i18next";
import Moment from "moment";
import { useMemo } from "react";
import _ from "lodash";
import {isNumber} from "lodash/lang";
import {
    uomLut,
    getSensorDataReportValueTypesFormat,
    maskStdAttributes,
    sensorDataReportValueTypes,
    simpleValues
} from "../../utils/CbvUtils";

const SensorReportData = ({ data, classes }) => {
    const headers= useMemo(() => {
        if(!data)
            return []
        let _headers = []
        _headers = data[0].sensorReport.map((report)=>({type: report.type, uom: report.uom}))
        
        return _headers
    }, data)

    const getValues = (report) => {
        let extensionValues = _.omit(report, maskStdAttributes)
        extensionValues = Object.keys(extensionValues)
        extensionValues = _.map(extensionValues, (extension) => ({
            name: extension,
            align: isNumber(report[extension]) ? 'right' : 'center',
            label: extension === 'component' ? `Component ${report[extension]}` : extension
        }))
        const stdValues = _.filter(sensorDataReportValueTypes, function (o) {
            if (!!report && !!report['component'] ) //&& o.name === sensorDataReportValueTypes.value.name)
                return false;
            else 
                return Object.keys(report).includes(o.name);
        })
    
        return _.concat(extensionValues, stdValues)
    }
    
    const renderHeader = (columnIndex, style) => {
        let h_data= headers[columnIndex-1]
        return (<div className={classes.stickyCell} style={{...style, padding: "5px",
                    background: "whitesmoke", display:"grid", maxWidth: "none", textAlign: "center",
                    borderRightColor: "lightgray", borderRightStyle: "solid", borderRightWidth: "1px",
                    borderBottomColor: "lightgray", borderBottomStyle: "solid", borderBottomWidth: "1px"}}>
                <Typography variant={'caption'}><strong>{h_data.type}</strong></Typography>
                <Typography
                    variant={'caption'}>{h_data.uom ? `(${uomLut[h_data.uom] || h_data.uom})` : ''}</Typography>
            </div>
        )
    }

    const renderFirstColumn = (rowIndex, style) => {
        let record = data[rowIndex-1]
        return <div style={{...style, padding: "5px", background: "whitesmoke",
                borderRightColor: "lightgray", borderRightStyle: "solid", borderRightWidth: "1px",
                    borderBottomColor: "lightgray", borderBottomStyle: "solid", borderBottomWidth: "1px"}} className={classes.stickyCell}>
            <ListItemText
            primary={<>
                {record?.sensorMetadata && (record.sensorMetadata?.time || record.sensorMetadata?.startTime) &&
                <Typography variant={'body2'}>
                    {i18next.t("formatters:dateTime", {date: Moment(record.sensorMetadata.time || record.sensorMetadata.startTime)})}
                </Typography>}
                {record?.sensorMetadata && (record.sensorMetadata?.endTime) &&
                <Typography variant={'body2'}>
                    - {i18next.t("formatters:dateTime", {date: Moment(record.sensorMetadata.endTime)})}
                </Typography>}
            </>}
            secondary={`${record?.sensorMetadata?.deviceID || ''}`}
            />
        </div>
    }

    const renderData = (rowIndex, columnIndex, style) => {
        let report = data[rowIndex-1].sensorReport[columnIndex-1]
        let sensorValuesFormats= getValues(report)
        //let column_width = 100 / sensorValuesFormats.length
        //let data_width= sensorValuesFormats.map(x => `${column_width}%`).join(" ")
        return  <div style={{
            ...style,
            whiteSpace: 'nowrap',
          }}><div style={{display: "grid", height:"100%", width:"100%"}}>
            {sensorValuesFormats.map((value, index) => (
                <div key={index} className={classes.tableBorder} style={{display: "grid-item", gridColumn: index+1, padding:'5px'}}>
                    {simpleValues.includes(value?.name) && sensorValuesFormats.length == 1 ? <></>
                        : <div style={{height: '50%', textAlign: 'center'}}>
                            <strong>{value?.label}</strong>
                        </div>
                    }
                    <div style={{height: '50%', textAlign:'center'}}>
                        {value.name === 'component' ? report['value'] : getSensorDataReportValueTypesFormat(value, report[value.name])}
                    </div>
                </div>
        ))}
        </div>
        </div>
    }

    const _cache =new CellMeasurerCache({
        defaultHeight: 70,
        defaultWidth: 150,
        fixedHeight: true,
    });


    const renderGridCell = ({columnIndex, key,rowIndex, style, parent})=> {

        return (<CellMeasurer
            cache={_cache}
            key={key}
            parent={parent}
            rowIndex={rowIndex}
            columnIndex={columnIndex}
            >
            {rowIndex==0?
                columnIndex==0?
                    <div style={{...style}}>&nbsp;</div>:
                    renderHeader(columnIndex, style)
                :
                columnIndex==0?
                    renderFirstColumn(rowIndex, style):
                    renderData(rowIndex, columnIndex, style)

            }

        </CellMeasurer>)
    }

    return (
        <AutoSizer disableHeight>
            {({width}) => ( 
                <MultiGrid
                    className={classes.grid}
                    deferredMeasurementCache={_cache}
                    columnWidth={_cache.columnWidth}
                    overscanColumnCount={0}
                    overscanRowCount={0}
                    fixedColumnCount={1}
                    fixedRowCount={1}
                    columnCount={headers.length + 1}
                    enableFixedColumnScroll
                    enableFixedRowScroll
                    height={150}
                    rowHeight={_cache.defaultHeight}
                    rowCount={data.length+1}
                    width={width}
                    hideTopRightGridScrollbar
                    hideBottomLeftGridScrollbar
                    cellRenderer={renderGridCell}/>
                )
            }
        </AutoSizer>
    )
}

export default SensorReportData;